import { IContactAddress, IResponse } from "@common/models";
import Api, { IOptions } from "@service/Api";
import { Action } from "./Proxy";

export function getMemberAddress<T = object, U = IContactAddress[]>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.GET:
            return Api.get<T, U>("Address", { ...options, raiseError: options?.raiseError ?? false });
    }
    return Promise.reject();
}

export function addMemberAddress<T = IContactAddress, U = IContactAddress>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Address/Create", { ...options, raiseError: options?.raiseError ?? true, captchaRequierd: options?.captchaRequierd ?? true });
    }
    return Promise.reject();
}

export function modifyMemberAddress<T = IContactAddress, U = string>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Address/Modify", { ...options, raiseError: options?.raiseError ?? true, captchaRequierd: options?.captchaRequierd ?? true });
    }
    return Promise.reject();
}

export function deleteMemberAddress<T = IContactAddress, U = string>(action: Action, options?: IOptions<T>): Promise<IResponse<U>> {
    switch (action) {
        case Action.POST:
            return Api.post<T, U>("Address/Delete", { ...options, raiseError: options?.raiseError ?? true, captchaRequierd: options?.captchaRequierd ?? true });
    }
    return Promise.reject();
}